exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "[data-v-62fae76f] .avue-crud__right {\n  display: none;\n}\n.el-dialog__wrapper .el-dialog[data-v-62fae76f] {\n  width: 61% !important;\n}\n.el-dialog__wrapper .el-dialog .dialog-main-tree[data-v-62fae76f] {\n  max-height: 400px;\n  overflow-y: auto;\n}\n.el-dialog__wrapper .el-form-item__label[data-v-62fae76f] {\n  width: 20% !important;\n  padding-right: 20px;\n}\n.el-dialog__wrapper .el-form-item__content[data-v-62fae76f] {\n  margin-left: 20% !important;\n}", ""]);

// exports
